import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconHelp = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M30.208 1.926c-7.926.434-15.483 4.12-20.793 10.138-5.211 5.907-7.904 13.576-7.501 21.36.167 3.233.702 5.93 1.75 8.816a30 30 0 0 0 8.4 12.345 30.14 30.14 0 0 0 13.312 6.817c4.28.968 9.074.957 13.373-.031 5.627-1.294 10.688-4.138 14.759-8.293 3.302-3.37 5.473-6.915 7.088-11.574 1.706-4.923 1.993-10.883.78-16.228-1.076-4.737-3.389-9.3-6.584-12.988-.648-.747-2.08-2.188-2.856-2.873a29.6 29.6 0 0 0-6.848-4.555c-4.67-2.246-9.622-3.223-14.88-2.934m-.192 4.031c-4.042.343-7.62 1.451-11.104 3.44-3.343 1.906-6.53 4.919-8.727 8.25a26.12 26.12 0 0 0-3.558 20.529 25.94 25.94 0 0 0 5.586 10.852 26.09 26.09 0 0 0 29.13 7.354c2.895-1.118 5.403-2.618 7.685-4.597 3.332-2.888 5.777-6.36 7.354-10.441a26.1 26.1 0 0 0 0-18.688c-1.577-4.08-4.022-7.553-7.354-10.441a25.9 25.9 0 0 0-17.156-6.318c-.686.005-1.522.032-1.856.06m1.152 9.064c-2.1.165-4.339 1.22-5.888 2.772-1.752 1.757-2.735 4.058-2.763 6.47-.006.601.011.717.157 1.037.595 1.3 2.257 1.605 3.236.595.402-.414.533-.731.594-1.436.109-1.25.298-1.921.767-2.715.994-1.684 2.812-2.735 4.737-2.736 1.843-.001 3.742 1.08 4.677 2.665.56.948.782 1.787.772 2.903-.009.874-.154 1.508-.522 2.278-.303.635-.531.957-1.067 1.508-.533.55-.968.835-1.916 1.255-1.101.488-1.263.578-1.818 1.015-.863.68-1.614 1.82-1.94 2.944-.139.479-.146.608-.146 2.584 0 2.055.002 2.083.149 2.36.634 1.187 2.215 1.466 3.165.556.574-.55.583-.59.621-2.596l.033-1.76.18-.367c.237-.483.509-.694 1.297-1.01a9.2 9.2 0 0 0 3.315-2.24c1.603-1.659 2.473-3.591 2.66-5.906.141-1.745-.219-3.483-1.053-5.088a8.9 8.9 0 0 0-1.698-2.316 9.54 9.54 0 0 0-7.549-2.772m-.13 28.26c-1.736.593-2.516 2.698-1.58 4.262.267.443.845.978 1.283 1.185a3.05 3.05 0 0 0 2.518 0c.439-.207 1.017-.742 1.282-1.185.77-1.286.411-2.957-.832-3.872-.725-.534-1.79-.69-2.67-.39" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconHelp.displayName = 'IconHelp';